import { render, staticRenderFns } from "./MileageIgnoreZones.vue?vue&type=template&id=21640fef&scoped=true&"
import script from "./MileageIgnoreZones.vue?vue&type=script&lang=ts&"
export * from "./MileageIgnoreZones.vue?vue&type=script&lang=ts&"
import style0 from "./MileageIgnoreZones.vue?vue&type=style&index=0&id=21640fef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21640fef",
  null
  
)

export default component.exports